import React  from "react";
import ScrollToTop from "react-scroll-to-top";

 


const Footer = () => {
    const imgM = "/images/syncuppro-logo.svg";
    return (
        <>

            
            <footer className="bg-gray p-b-10 p-t-50">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-12 col-md-12 col-sm-12 p-b-10 m-b-50">
                            <div className="footer-logo">
                                <a target="_blank" href="/#" title="Syncuppro- Hire the Best Compliance Expert for your needs"> <img src={window.location.origin + imgM} alt="syncuppro-logo" /></a>
                            </div>
                            <p className="footer-desc">Trusted Partner in Compliance Journey</p>
                        </div>
                    </div>

                    <p className="m-0 text-center"> <i class="fa-solid fa-copyright" />  2022-{new Date().getFullYear()} Syncuppro. All rights reserved.</p>

                </div>
            </footer>
            <ScrollToTop smooth="true" component={< i className="fa fa-arrow-up text-white  font-size-7"></i>} className="btn-circle  scroll-up media-icon     bg-green rounded-5  text-white  font-size-7  " />
        </>
    );
};

export default Footer;